import { useState } from 'react'
import Header from '../../components/Header'
import BigText from '../../components/BigText'
import MediumText from '../../components/MediumText'
import Footer from '../../components/Footer'
import SignIn from '../../layouts/SignIn'
import Loader from '../../utils/loader'
import { useStyles } from './styles.js'
const LandingPage = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  return (
    <div className={classes.background}>
      <Loader loading={loading}></Loader>
      <Header data-testid="header"></Header>
      <BigText text="Battery Bonus Program"></BigText>
      <MediumText text="Validation Portal"></MediumText>
      <SignIn setLoading={setLoading}></SignIn>
      <Footer></Footer>
    </div>
  )
}
export default LandingPage
